const config = document.getElementById('smoon-optional-modules');
const modules = config ? JSON.parse(config.textContent) : {};
const jobs = new Map();
const selector = Object.keys(modules).join(',');

function activate(element) {
  const url = modules[element.localName];
  if (!url || jobs.has(url)) return;
  jobs.set(url, import(url).catch(error => {
    jobs.delete(url);
    console.warn('Optional theme component could not be loaded.', error);
  }));
}

function scan(root) {
  if (!selector) return;
  if (root instanceof Element && root.matches(selector)) activate(root);
  root.querySelectorAll?.(selector).forEach(activate);
}

scan(document);
if (selector) {
  const observer = new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) roots.add(node);
      }
    }
    for (const root of roots) {
      if (!root.isConnected) continue;
      if ([...roots].some(other => other !== root && other.contains(root))) continue;
      scan(root);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
